import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
// components
import Modal from 'components/Modal';
import { FormattedMessage } from 'react-intl';
import ExpandSection from './ExpandSection';
// utils
import moment from 'moment';
import classnames from 'classnames/bind';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// styles
import styles from './SynchroniseModal.module.scss';

const cn = classnames.bind(styles);

const SynchroniseModal = ({ groups, countryCode }) => {
  return (
    <Modal
      title={(
        <FormattedMessage
          id="component.groups.synchronizationTitle"
          values={{
            date: formatDateForUser(moment(), countryCode),
          }}
        />
      )}
    >
      <section className="modal-body">
        {!!groups.created.length && (
          <ExpandSection
            groups={groups.created}
            success
            icon={<i className={cn('fa fa-2x fa-check green')} />}
          />
        )}
        {!!groups.not_created.length && (
          <>
            <hr />
            <ExpandSection
              groups={groups.not_created}
              icon={<i className={cn('fa fa-2x fa-ban red')} />}
            />
          </>
        )}
      </section>
    </Modal>
  );
};


SynchroniseModal.propTypes = {
  groups: T.object.isRequired,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state),
  })
)(SynchroniseModal);
